export const BREEDER_MISSION_DISPLAY_TYPE = 'breeder_mission';
export const GENERAL_MISSION_DISPLAY_TYPE = 'mission';
